import React from 'react';
import { useStoreActions } from "../store/store-context";
import { BusinessChannelEventBinder, PusherEvent } from "../pusher";
/** Binds a callback to the pusher event for in-app-notifications. */

export default function InAppNotificationBinder() {
  const {
    fetchInAppNotifications
  } = useStoreActions();
  return /*#__PURE__*/React.createElement(BusinessChannelEventBinder, {
    eventName: PusherEvent.MailboxUpdated,
    callback: () => fetchInAppNotifications(),
    onBind: () => fetchInAppNotifications()
  });
}